// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"249":"4719e8b2","486":"69a05ae0","541":"a8371255"}[chunkId] + ".chunk.js";
};